import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

// accessors were previously here
export * from './accessors';

export const FETCH_SESSION_PLANS_REQUEST = 'FETCH_SESSION_PLANS_REQUEST';
export const FETCH_SESSION_PLANS_SUCCESS = 'FETCH_SESSION_PLANS_SUCCESS';
export const FETCH_SESSION_PLANS_FAILURE = 'FETCH_SESSION_PLANS_FAILURE';

const buildSessionPlansUrl = (groupId) => buildUrl(`/groups/${groupId}/sessions`);
const method = 'GET';

export function fetchSessionPlansIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method, url: buildSessionPlansUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchSessionPlans(groupId));
  };
}

export function fetchSessionPlans(groupId) {
  return (dispatch) => {
    const url = buildSessionPlansUrl(groupId);

    return dispatch(fetchSessionPlansRequest()).payload
      .then((response) => dispatch(fetchSessionPlansSuccess(response)))
      .catch((error) => dispatch(fetchSessionPlansFailure(error)));

    function fetchSessionPlansRequest() {
      return ApiCall.createAction({
        type: FETCH_SESSION_PLANS_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchSessionPlansSuccess(sessions) {
      return ApiCall.createAction({
        type: FETCH_SESSION_PLANS_SUCCESS,
        payload: sessions,
        url,
        method,
        groupId,
      });
    }

    function fetchSessionPlansFailure(error) {
      return ApiCall.createAction({
        type: FETCH_SESSION_PLANS_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/SessionPlans/actions.js